import { render } from "./budgets-index.vue?vue&type=template&id=f117de3e"
import script from "./budgets-index.vue?vue&type=script&lang=js"
export * from "./budgets-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__